<template>
  <div>
    <div class="form my-4">
      <!-- Booking status -->
      <h6
        class="text-success font-weight-bold pl-5 mb-4"
        v-if="bookingSuccess === true"
      >Your cab has been booked succesfully.</h6>
      <h6
        class="text-danger font-weight-bold pl-5 mb-4"
        v-if="bookingSuccess === false"
      >Cannot complete your request, try again later.</h6>
      <!-- /Booking status -->
      <!-- Booking Form -->
      <form action @submit.prevent="book" class="booking-form">
        <BaseInput
          :label="'Pickup address'"
          :iconClass="'fleet-pickup'"
          v-model="pickup_addr"
          v-validate="'required'"
          data-vv-name="pickup"
        >
          <slot>
            <span v-show="errors.has('pickup')" class="error">This field is required.</span>
          </slot>
        </BaseInput>
        <BaseInput
          :label="'Dropoff address'"
          :iconClass="'fleet-drop'"
          v-model="dest_addr"
          v-validate="'required'"
          name="dest"
        >
          <slot>
            <span v-show="errors.has('dest')" class="error">This field is required.</span>
          </slot>
        </BaseInput>
        <BaseInput
          :type="'number'"
          :min="0"
          :label="'No of persons'"
          :iconClass="'fleet-person'"
          v-model="no_of_person"
          v-validate="'required'"
          name="person"
        >
          <slot>
            <span v-show="errors.has('person')" class="error">This field is required.</span>
          </slot>
        </BaseInput>
        <div class="form-input">
          <v-select
            class="vue-select"
            v-model="vehicle"
            :searchable="false"
            :placeholder="'Select vehicle type'"
            label="vehicle_type"
            :options="vehicles"
            v-validate="'required'"
            data-vv-name="vehicles"
          ></v-select>
          <span v-show="errors.has('vehicles')" class="error">This field is required.</span>
        </div>
        <BaseTextarea :label="'Other things that we should know'" :rows="3" v-model="remarks" />
        <!-- Submit -->
        <BaseButton class="mb-3" />
      </form>
      <!-- /Booking Form -->
    </div>
  </div>
</template>

<script>
import api from "@/api.js";
import auth from "@/auth.js";
import BaseInput from "@/components/ui/Elements/BaseInput";
import BaseTextarea from "@/components/ui/Elements/BaseTextarea";
import BaseButton from "@/components/ui/Elements/BaseButton";
export default {
  components: {
    BaseInput,
    BaseTextarea,
    BaseButton
  },
  data() {
    return {
      bookingSuccess: null,
      pickup_addr: "",
      dest_addr: "",
      no_of_person: "",
      vehicle: "",
      remarks: "",
      vehicles: []
    };
  },
  updated() {
    // console.log(this.$store.state.user_id);
    // console.log(this.$store.state.api_token);
  },
  mounted() {
    this.axios.get(`${api.url}/vehicle-types`).then(response => {
      this.vehicles = response.data;
    });
  },
  methods: {
    book() {
      if (auth.checkAuth()) {
        this.$validator.validateAll().then(result => {
          if (result) {
            this.axios
              .post(`${api.url}/book-now`, {
                booking_type: 0,
                source_address: this.pickup_addr,
                dest_address: this.dest_addr,
                no_of_persons: this.no_of_person,
                vehicle_typeid: this.vehicle.id,
                user_id: this.$store.state.user_id,
                note: this.remarks,
                api_token: this.$store.state.api_token
              })
              .then(response => {
                if (response.data.success === "1") {
                  this.bookingSuccess = true;
                  [
                    this.pickup_addr,
                    this.dest_addr,
                    this.no_of_person,
                    this.vehicle,
                    this.remarks
                  ] = "";
                } else {
                  this.bookingSuccess = false;
                }
              });
          }
        });
      } else {
        this.$router.push({
          name: "login",
          params: { book: true }
        });
      }
    }
  }
};
</script>

<style lang="scss" scoped>
</style>